export class BookWrapper {
    id: number;
    title: string;
    releasedDate?: Date | string | number;
    prefix?: string;
    coverPath: string;
    schoolLevel?: Array<string>;
}
